import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTheme } from '@mui/material/styles';
import RecifeBemLogo from "~/images/illustrations/bora-impactar.svg";
import { APP_ROUTES } from '~/single-page/constants/routes';

export default function UpdateSuccess() {
  const theme = useTheme();

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#CBEFFF',
        position: 'relative',
        pt: { xs: 8, sm: 8, md: 10 },
        pb: { xs: 4, sm: 6, md: 8 },
        px: { xs: 2, sm: 3, md: 4 }
      }}
    >
      <Container 
        maxWidth="lg" 
        sx={{ 
          p: 0,
          height: '100%',
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' }
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: { xs: 2.5, sm: 3, md: 3.5 }, 
            borderRadius: { xs: 2, sm: 3 },
            bgcolor: 'white',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            width: '100%',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, #294BB6 0%, #4F97FF 100%)'
            }
          }}
        >
          <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}>
            <img 
              src={RecifeBemLogo} 
              alt="Bora Impactar" 
              style={{
                width: '160px',
                maxWidth: '100%',
                height: 'auto',
                marginBottom: '20px'
              }}
            />

            <CheckCircleIcon 
              sx={{ 
                fontSize: { xs: 64, sm: 80 },
                color: theme.palette.success.main,
                mb: 3
              }}
            />

            <Typography 
              variant="h4" 
              gutterBottom 
              sx={{ 
                fontWeight: 600,
                color: theme.palette.success.main,
                textAlign: 'center',
                fontSize: { xs: '1.5rem', sm: '2rem' },
                mb: 2
              }}
            >
              Atualização Realizada com Sucesso!
            </Typography>

            <Typography 
              variant="body1" 
              sx={{ 
                textAlign: 'center',
                color: theme.palette.text.secondary,
                maxWidth: '600px',
                mb: 4,
                fontSize: { xs: '1rem', sm: '1.1rem' }
              }}
            >
              Os dados da sua organização foram atualizados com sucesso. 
              Você pode verificar o status do seu cadastro a qualquer momento.
            </Typography>

            <Button 
              component={Link}
              to={APP_ROUTES.REGISTRATION_STATUS}
              variant="contained" 
              color="primary"
              sx={{
                py: { xs: 1.25, sm: 1.5 },
                px: { xs: 3, sm: 4 },
                fontSize: { xs: '1rem', sm: '1.1rem' },
                fontWeight: 600,
                borderRadius: { xs: 1.5, sm: 2 },
                background: 'linear-gradient(90deg, #294BB6 0%, #4F97FF 100%)',
                transition: 'all 0.3s ease',
                textTransform: 'none',
                '&:hover': {
                  background: 'linear-gradient(90deg, #4F97FF 0%, #294BB6 100%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(41, 75, 182, 0.25)'
                },
                '&:active': {
                  transform: 'translateY(0)'
                }
              }}
            >
              Ver Status do Cadastro
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
} 